import {
  Grid,
  GridColumn as Column,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuFilter,
} from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { formatDate } from "@progress/kendo-intl";

import { useQueryGetImportPage } from "../../data/services/importService";
import AddImportModel from "./AddImportModel";
import ImportErrorModel from "./ImportErrorModel";
import OEContext from "../../layouts/OEContext";
import { IsImportAutoStepsComplete, ImportStatus } from "./ImportStatusHelper";
import { createPortal } from "react-dom";

const RateImport = () => {
  const navigate = useNavigate();
  const oePeriod = React.useContext(OEContext);

  const [visible, setVisible] = React.useState(false);
  const [errorModelVisible, setErrorModelVisible] = React.useState(false);
  const [importId, setImportId] = React.useState(0);
  const gridRef = React.useRef(null);

  const [gridState, setGridState] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
  });

  const page = Math.floor(gridState.skip / gridState.take) + 1;

  const { isFetching: importPageLoading, data: apiResponse } =
    useQueryGetImportPage(
      oePeriod?.oePeriodId,
      page,
      gridState.take,
      gridState.sort,
    );

  const pagedData = apiResponse?.data;

  const pagerSetting = {
    buttonCount: 5,
    info: true,
    type: "numeric",
    pageSizes: [10, 20, 50, 100, 200],
    previousNext: true,
  };

  const toggleDialog = () => setVisible(!visible);

  const toggleErrorDialog = (importFileQueueId) => {
    setErrorModelVisible(!errorModelVisible);
    setImportId(importFileQueueId);
  };

  const onDataStateChange = (event) => {
    setGridState(event.dataState);
  };

  const actionCell = (props) => {
    let isAutoComplete = IsImportAutoStepsComplete(props.dataItem.importStatus);
    if (props.dataItem.importStatus === ImportStatus.ParsingError) {
      return (
        <td>
          <Button
            onClick={() => toggleErrorDialog(props.dataItem.importFileQueueId)}
            fillMode="flat"
            themeColor="error"
          >
            View Error Details
          </Button>
        </td>
      );
    } else if (!isAutoComplete) {
      return (
        <td style={{ paddingLeft: "40px" }}>
          <span className="k-icon k-i-loading"></span>
        </td>
      );
    } else {
      return (
        <td>
          <Button
            onClick={() =>
              navigate(
                `/admin/rateimportsummary/${props.dataItem.importFileQueueId}/grid`,
              )
            }
            fillMode="flat"
            themeColor="success"
          >
            View Data
          </Button>
        </td>
      );
    }
  };

  const dateCell = (props) => (
    <td>{formatDate(new Date(props.dataItem.dateCreated + "Z"), "G")}</td>
  );

  const columnMenuHeader = (field) => {
    var active = GridColumnMenuFilter.active(field, gridState.filter);
    return active ? "active" : "";
  };

  const ColumnMenu = (props) => (
    <GridColumnMenuFilter {...props} expanded={true} hideSecondFilter={true} />
  );

  const ColumnCheckboxMenu = (props) => (
    <GridColumnMenuCheckboxFilter
      {...props}
      data={pagedData?.items || []}
      expanded={true}
    />
  );

  const loadingPanelMarkup = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );

  const LoadingPanel = (props) => {
    const { gridRef } = props;
    const gridContent =
      gridRef.current && gridRef.current.querySelector(".k-grid-content");
    return gridContent
      ? createPortal(loadingPanelMarkup, gridContent)
      : loadingPanelMarkup;
  };

  return (
    <div>
      <div
        style={{
          justifyContent: "space-between",
          display: "flex",
          paddingBottom: 10,
        }}
      >
        <h2 style={{ margin: "10px" }}>Carrier Rate Import</h2>
      </div>
      <div
        style={{
          justifyContent: "space-around",
          paddingTop: "40px",
          paddingBottom: "60px",
          display: "flex",
        }}
      >
        <Button
          onClick={toggleDialog}
          themeColor={"primary"}
          disabled={!oePeriod}
          size={"large"}
          iconClass="k-icon k-i-upload"
        >
          Import New File
        </Button>
      </div>
      {importPageLoading ? <LoadingPanel gridRef={gridRef} /> : null}
      <Grid
        style={{ height: "600px" }}
        sortable={{ allowUnsort: true, mode: "multiple" }}
        pageable={pagerSetting}
        loading={importPageLoading}
        data={pagedData?.items || []}
        total={pagedData?.totalCount || 0}
        {...gridState}
        onDataStateChange={onDataStateChange}
      >
        <Column
          field="carrier.carrierName"
          title="Carrier Name"
          // columnMenu={ColumnCheckboxMenu}
          width={130}
        />
        <Column
          field="carrierType.carrierTypeDesc"
          title="Type"
          // columnMenu={ColumnCheckboxMenu}
          width={130}
        />
        <Column
          field="fileName"
          title="Filename"
          // columnMenu={ColumnMenu}
        />
        <Column
          field="dateCreated"
          cell={dateCell}
          title="Date Created"
          width={180}
        />
        <Column
          field="importStatusDesc"
          title="Status"
          // columnMenu={ColumnCheckboxMenu}
          width={180}
        />
        <Column
          field="Action"
          title="Action"
          cell={actionCell}
          width={180}
          sortable={false}
        />
      </Grid>

      {visible && (
        <AddImportModel
          visible={visible}
          toggleDialog={toggleDialog}
          oePeriod={oePeriod}
        />
      )}
      {errorModelVisible && (
        <ImportErrorModel
          visible={errorModelVisible}
          toggleDialog={toggleErrorDialog}
          importId={importId}
        />
      )}
    </div>
  );
};

export default RateImport;
